<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("BUTTONS.add_notification") }}</h4>
    </div>

    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #446e80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.titleAr')"
                v-model.trim="data.titleAr"
                required
              />

              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.titleEn')"
                v-model.trim="data.titleEn"
                required
              />

              <base-input
                col="6"
                rows="7"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.contentAr')"
                v-model.trim="data.contentAr"
                required
              />

              <base-input
                col="6"
                rows="7"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.contentEn')"
                v-model.trim="data.contentEn"
                required
              />
            </div>
          </div>

          <base-select-input
            col="6"
            :optionsList="receiverTypes"
            :placeholder="$t('PLACEHOLDERS.receiverType')"
            v-model="data.receiverType"
            required
          />

          <base-select-input
            v-if="data.clients && data.receiverType.value === 'client'"
            col="6"
            :optionsList="data.clients"
            :placeholder="$t('PLACEHOLDERS.clients_menu')"
            v-model="data.client"
            required
            multiple
          />

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "CreateNotification",

  computed: {
    receiverTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.allClients"),
          value: "allClients",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.specificClients"),
          value: "client",
        },
      ];
    },
  },

  data() {
    return {
      isWaitingRequest: false,
      data: {
        receiverType: {
          id: null,
          name: null,
          value: null,
        },
        clients: [],
        client: [],
        titleAr: null,
        titleEn: null,
        contentAr: null,
        contentEn: null,
      },
    };
  },

  methods: {
    async getClients() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: `clients?page=0&limit=0&isActive=1`,
        });

        this.data.clients = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!this.data.receiverType?.value) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.receiverType"));
        return;
      }

      if (
        this.data.receiverType?.value === "client" &&
        !this.data.client.length
      ) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.clientAtLeast"));
        return;
      }

      if (!this.data.titleAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.titleAr"));
        return;
      }

      if (!this.data.titleEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.titleEn"));
        return;
      }

      if (!this.data.contentAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.contentAr"));
        return;
      }

      if (!this.data.contentEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.contentEn"));
        return;
      }

      this.submitForm();
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();

      if (this.data.receiverType.value === "allClients") {
        REQUEST_DATA.append("to_type", "allClients");
      } else if (this.data.receiverType.value === "client") {
        this.data.client.forEach((element) => {
          REQUEST_DATA.append("users[]", element.id);
        });
      }

      REQUEST_DATA.append("title[ar]", this.data.titleAr);
      REQUEST_DATA.append("title[en]", this.data.titleEn);
      REQUEST_DATA.append("body[ar]", this.data.contentAr);
      REQUEST_DATA.append("body[en]", this.data.contentEn);

      try {
        await this.$axios({
          method: "POST",
          url: `notification/store`,
          data: REQUEST_DATA,
        });

        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.sentSuccessfully"));
        this.$router.push({ path: "/all-notifications/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
  },

  created() {
    this.getClients();
  },
};
</script>
